/** AdSense configuration. Set VITE_ADSENSE_CLIENT (e.g. "ca-pub-1234567890123456"). */
export const ADSENSE_CLIENT: string =
  (import.meta.env["VITE_ADSENSE_CLIENT"] as string | undefined) ?? "";

export const ADS_ENABLED = ADSENSE_CLIENT.startsWith("ca-pub-");

/**
 * Real ad-unit ids, configured per placement. Until a placement has a real
 * data-ad-slot from AdSense, nothing is rendered — an empty "Advertisement"
 * tray is worse than no ad at all.
 */
export const AD_SLOTS: Record<string, string> = {
  home: (import.meta.env["VITE_ADSENSE_SLOT_HOME"] as string | undefined) ?? "",
  model: (import.meta.env["VITE_ADSENSE_SLOT_MODEL"] as string | undefined) ?? "",
  blog: (import.meta.env["VITE_ADSENSE_SLOT_BLOG"] as string | undefined) ?? "",
};

/** AdSense unit ids are numeric strings; anything else is a placeholder. */
export function resolveAdSlot(placement?: string, slot?: string): string | null {
  const value = slot ?? (placement ? AD_SLOTS[placement] : undefined) ?? "";
  return /^\d{6,}$/.test(value) ? value : null;
}


/** Publisher id without the "ca-" prefix, as required by ads.txt. */
export function adsTxtBody(client: string): string {
  const pub = client.replace(/^ca-/, "");
  return `google.com, ${pub}, DIRECT, f08c47fec0942fa0\n`;
}

let adsRequested = false;

/**
 * Injects the AdSense tag on demand.
 *
 * Loading it in <head> made every page request ads (and set third-party
 * cookies) before the visitor ever saw an ad unit, which cost first-load
 * performance and Best Practices. Ownership is still verified through the
 * google-adsense-account meta tag and ads.txt, both of which stay in place.
 */
export function loadAdSense(): void {
  if (!ADS_ENABLED || adsRequested || typeof document === "undefined") return;
  adsRequested = true;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  document.head.appendChild(s);
}
